export const pageItems = [
  { label: "Upgrade", path: "/upgrade", status: "enabled" },
  { label: "Advertise", path: "/advertise", status: "enabled" },
  { label: "Invest", path: "/invest", status: "enabled" },
  { label: "Contact us", path: "#contact-us", status: "enabled" },
];
